import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WaitingComponent } from '@components/waiting/waiting.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [WaitingComponent],
  exports: [WaitingComponent],
  imports: [CommonModule, MatProgressSpinnerModule],
})
export class WaitingModule {}
